import { render, staticRenderFns } from "./PublisherList.vue?vue&type=template&id=78eb38c6"
import script from "./PublisherList.vue?vue&type=script&lang=js"
export * from "./PublisherList.vue?vue&type=script&lang=js"
import style0 from "./PublisherList.vue?vue&type=style&index=0&id=78eb38c6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports